import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
} from "@fortawesome/free-solid-svg-icons";

const NotificationIcon = ({count}) => {
  return (
    <Link to="notifications" className={`relative ${count?"text-white":"text-purple-500"}`}>
      <FontAwesomeIcon icon={faBell} size="lg" />
      {count > 0 && (
        <span className="absolute -top-1 -right-2 bg-red-600 text-white text-xs font-bold px-1.5 rounded-full">
          {count}
        </span>
      )}
    </Link>
  );
};

export default NotificationIcon;
